<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-topo">
            <div class="card-body p-4">
              <div
                class="d-flex flex-row align-items-center justify-content-between"
              >
                <div class="d-flex align-items-center flex-grow-1 min-w-0">
                  <router-link
                    :to="'/oficinas-treinamentos'"
                    class="mr-3 flex-shrink-0"
                  >
                    <button class="btn btn-voltar-circular" title="Voltar">
                      <i class="icofont-arrow-left"></i>
                    </button>
                  </router-link>

                  <div class="d-flex flex-column min-w-0">
                    <h1 class="h5 mb-1 font-weight-bold text-dark">
                      Meus Certificados
                    </h1>
                    <p class="text-muted small mb-0 text-truncate">
                      Visualize seus certificados de treinamentos e oficinas.
                    </p>
                  </div>
                </div>

                <!-- Lado Direito: Ajuda -->
                <div class="d-flex align-items-center flex-shrink-0">
                  <modal-informacao
                    :isIframe="true"
                    urlIframe="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2351"
                    pageIdentifier="oficinas-treinamentos-certificados"
                    :enableBadge="
                      Number(
                        $store.state.permissoesRaw
                          ?.oficinas_treinamentos_certificados_ajuda || 0
                      ) > 0
                    "
                    :badgeValue="
                      $store.state.permissoesRaw
                        ?.oficinas_treinamentos_certificados_ajuda || 0
                    "
                    keyAjuda="oficinas_treinamentos_certificados_ajuda"
                  ></modal-informacao>
                </div>
              </div>
            </div>
          </div>

          <div class="box" style="margin-top: 0px">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar certificado"
                  class="input-bottom"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                @pagination="getPagination"
                :page="currentPage"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                :loading="loading"
                loading-text="Carregando, Por favor espere"
                :headers="headers"
                :items="certificados"
                :search="search"
                item-key="id"
                class="elevation-1"
                :expanded.sync="expanded"
                @update:expanded="onExpandedUpdate"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    indeterminate
                    color="primary"
                    height="4"
                  ></v-progress-linear>
                </template>
                <template v-slot:[`footer.page-text`]="items">
                  <span class="paginacao">
                    {{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }}
                    {{
                      items.itemsLength === 1 ? 'certificado' : 'certificados'
                    }}
                  </span>
                </template>

                <template v-slot:item.titulo="{ item }">
                  <div class="d-flex flex-column" :data-item-id="item.id">
                    <span class="font-weight-bold">{{ item.titulo }}</span>
                    <span class="text-muted small">{{ item.subtitulo }}</span>
                  </div>
                </template>

                <template v-slot:item.horas_acumuladas="{ item }">
                  <span class="font-weight-bold" :data-item-id="item.id"
                    >{{ item.horas_acumuladas }}h</span
                  >
                </template>

                <template v-slot:item.ult_atividade="{ item }">
                  <span :data-item-id="item.id">{{
                    formatarData(item.ult_atividade)
                  }}</span>
                </template>

                <template v-slot:item.certificados="{ item }">
                  <div class="certificados-coluna">
                    <button
                      v-if="todasOficinasAvaliadas(item)"
                      type="button"
                      class="btn-certificado"
                      @click.stop="visualizarCertificadoPrincipal(item)"
                      :data-item-id="item.id"
                    >
                      <i class="icofont-certificate"></i>
                      Visualizar
                    </button>
                    <button
                      v-else
                      type="button"
                      class="btn-avaliar-principal"
                      @click.stop="expandirParaAvaliar(item)"
                      :data-item-id="item.id"
                    >
                      <i class="icofont-star"></i>
                      Avaliar
                    </button>
                  </div>
                </template>

                <template v-slot:item.data-table-expand="{ item }">
                  <button
                    @click.stop="toggleExpandByItem(item)"
                    class="btn-expand"
                    :aria-expanded="isItemExpanded(item)"
                    :data-item-id="item.id"
                  >
                    <i
                      :class="
                        isItemExpanded(item)
                          ? 'icofont-simple-up'
                          : 'icofont-simple-down'
                      "
                    ></i>
                  </button>
                </template>

                <template v-slot:expanded-item="{ item, headers }">
                  <td :colspan="headers.length" class="expanded-cell">
                    <div class="detalhes-oficinas-wrapper">
                      <v-data-table
                        v-if="
                          item.detalhes_oficinas &&
                          item.detalhes_oficinas.length > 0
                        "
                        :headers="headersOficinas"
                        :items="item.detalhes_oficinas"
                        item-key="id"
                        hide-default-footer
                        class="tabela-oficinas elevation-0"
                        :items-per-page="-1"
                      >
                        <template v-slot:item.sub_titulo="{ item: oficina }">
                          <span class="tag-categoria">{{
                            oficina.sub_titulo || item.subtitulo
                          }}</span>
                        </template>

                        <template v-slot:item.inicio="{ item: oficina }">
                          <span class="certificado-data">
                            {{ formatarData(oficina.inicio) }}
                            <span
                              v-if="
                                oficina.fim &&
                                !saoDatasIguais(oficina.inicio, oficina.fim)
                              "
                            >
                              – {{ formatarData(oficina.fim) }}
                            </span>
                          </span>
                        </template>

                        <template v-slot:item.meio="{ item: oficina }">
                          <span class="certificado-meio">
                            {{ oficina.meio }}
                          </span>
                        </template>

                        <template v-slot:item.qtd_horas="{ item: oficina }">
                          <span class="horas-individual">
                            {{ oficina.qtd_horas }}h
                          </span>
                        </template>

                        <template v-slot:item.acoes="{ item: oficina }">
                          <div class="certificado-acoes">
                            <button
                              v-if="oficina.st_part_avaliou === 0"
                              type="button"
                              class="btn-avaliar"
                              @click="handleAvaliar(oficina, item)"
                            >
                              <i class="icofont-star"></i>
                              Avaliar
                            </button>
                            <button
                              v-else
                              type="button"
                              class="btn-avaliar btn-avaliado"
                              disabled
                            >
                              <i class="icofont-star"></i>
                              Avaliado
                            </button>
                          </div>
                        </template>
                      </v-data-table>
                      <div v-else class="certificado-empty">
                        Nenhuma oficina encontrada.
                      </div>
                    </div>
                  </td>
                </template>

                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b>Nenhum certificado encontrado.</b>
                  </div>
                </template>

                <template v-slot:no-results>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Tente outro termo de
                      busca.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para visualizar PDF -->
    <ModalCertificado
      :mostrar="mostrarModalPdf"
      :url-pdf="urlPdf"
      :loading="loadingPdf"
      :nome-arquivo="nomeArquivoPdf"
      @fechar="fecharModalPdf"
    />

    <!-- Modal de Avaliação -->
    <ModalAvaliacao
      :mostrar="mostrarModalAvaliacao"
      :oficina-id="oficinaSelecionadaParaAvaliacao?.id"
      :nome-oficina="
        oficinaSelecionadaParaAvaliacao?.sub_titulo ||
        oficinaSelecionadaParaAvaliacao?.titulo ||
        ''
      "
      :oficina="oficinaSelecionadaParaAvaliacao"
      @fechar="fecharModalAvaliacao"
      @avaliacao-enviada="onAvaliacaoEnviada"
    />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import { jwtDecode } from 'jwt-decode'
import ModalCertificado from './components/ModalCertificado.vue'
import ModalAvaliacao from './components/ModalAvaliacao.vue'
import ModalInformacao from '@/components/ModalInformacao.vue'

export default {
  name: 'Certificados',
  components: {
    Menu,
    ModalCertificado,
    ModalAvaliacao,
    ModalInformacao,
  },
  data() {
    return {
      cpf: null,
      loading: false,
      certificados: [],
      currentPage: 1,
      search: '',
      expanded: [],
      clickHandlerAdded: false,
      mostrarModalPdf: false,
      urlPdf: null,
      loadingPdf: false,
      nomeArquivoPdf: null,
      mostrarModalAvaliacao: false,
      oficinaSelecionadaParaAvaliacao: null,
      headers: [
        {
          text: 'Treinamento / Oficina',
          align: 'start',
          filterable: true,
          value: 'titulo',
          width: '50%',
        },
        {
          text: 'Horas Acumuladas',
          align: 'start',
          filterable: false,
          value: 'horas_acumuladas',
          width: '15%',
        },
        {
          text: 'Última Atividade',
          align: 'start',
          filterable: false,
          value: 'ult_atividade',
          width: '15%',
        },
        {
          text: 'Certificados',
          align: 'start',
          filterable: false,
          value: 'certificados',
          sortable: false,
          width: '12%',
        },
        {
          text: '',
          align: 'end',
          filterable: false,
          value: 'data-table-expand',
          sortable: false,
          width: '48px',
        },
      ],
      headersOficinas: [
        {
          text: 'Treinamento / Oficina',
          align: 'start',
          sortable: false,
          value: 'sub_titulo',
        },
        {
          text: 'Data',
          align: 'start',
          sortable: true,
          value: 'inicio',
        },
        {
          text: 'Meio',
          align: 'start',
          sortable: true,
          value: 'meio',
        },
        {
          text: 'C. Horária',
          align: 'start',
          sortable: true,
          value: 'qtd_horas',
        },
        {
          text: 'Ações',
          align: 'start',
          sortable: false,
          value: 'acoes',
        },
      ],
    }
  },
  computed: {
    codIbge() {
      return this.$store.state.cod_ibge || ''
    },
    cpfUsuario() {
      if (this.cpf) return this.cpf
      if (this.$store.state.accessToken) {
        try {
          const decoded = jwtDecode(this.$store.state.accessToken)
          return decoded.cpf || decoded.nu_cpf || null
        } catch {
          return null
        }
      }
      return null
    },
    nomeParticipante() {
      try {
        const token = this.$store.state.accessToken
        if (!token) return ''
        const decoded = jwtDecode(token)
        return decoded.nome || decoded.username || ''
      } catch {
        return ''
      }
    },
  },
  async mounted() {
    this.loading = true
    try {
      await this.buscarCpfUsuario()
      await this.buscarCertificados()
      this.$nextTick(() => {
        this.ajustarLarguraExpanded()
        this.adicionarClickNasLinhas()
      })
    } finally {
      this.loading = false
    }
  },
  beforeDestroy() {
    if (this.urlPdf) {
      window.URL.revokeObjectURL(this.urlPdf)
    }
    if (this._clickHandler) {
      const tbody = document.querySelector('.v-data-table tbody')
      if (tbody) {
        tbody.removeEventListener('click', this._clickHandler)
      }
    }
  },
  methods: {
    async buscarCpfUsuario() {
      try {
        const userAuth = await this.$api.post('/app/auth/usuario', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (userAuth && userAuth.data) {
          this.cpf = userAuth.data.cpf
        }
      } catch {
        try {
          if (this.$store.state.accessToken) {
            const decoded = jwtDecode(this.$store.state.accessToken)
            this.cpf = decoded.cpf || decoded.nu_cpf || null
          }
        } catch {}
      }
    },
    async buscarCertificados() {
      const codIbge = this.codIbge
      const cpf = this.cpfUsuario
      if (!codIbge || !cpf) return
      const cpfLimpo = String(cpf).replace(/\D/g, '')
      const url = `/app/oficinas-treinamentos/${codIbge}/participantes/${cpfLimpo}/certificados`
      try {
        const response = await this.$api.get(url)
        if (
          response.data &&
          response.data.error === false &&
          Array.isArray(response.data.data)
        ) {
          this.certificados = response.data.data.map((cert, index) => ({
            ...cert,
            id: `${cert.titulo}-${cert.subtitulo}-${index}`,
            detalhes_oficinas: this.parseDetalhesOficinas(
              cert.detalhes_oficinas
            ),
          }))
        } else {
          this.certificados = []
        }

        this.$nextTick(() => {
          this.adicionarClickNasLinhas()
        })
      } catch (error) {
        this.certificados = []
        this.$toast.error('Erro ao carregar certificados.', 'Erro', {
          position: 'topRight',
          timeout: 3000,
        })
      }
    },
    parseDetalhesOficinas(detalhesString) {
      if (!detalhesString) return []
      try {
        const parsed = JSON.parse(detalhesString)
        if (!Array.isArray(parsed)) return []
        return parsed.map((oficina, index) => ({
          ...oficina,
          id: oficina.id || `oficina-${index}-${Date.now()}`,
        }))
      } catch {
        return []
      }
    },
    formatarData(data) {
      if (!data) return '-'
      try {
        if (typeof data === 'string' && data.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [year, month, day] = data.split('-')
          const date = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day)
          )
          return date.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })
        }
        const date = new Date(data)
        if (isNaN(date.getTime())) return data
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      } catch {
        return data
      }
    },
    saoDatasIguais(data1, data2) {
      if (!data1 || !data2) return false
      try {
        const date1 = this.normalizarData(data1)
        const date2 = this.normalizarData(data2)
        return date1.getTime() === date2.getTime()
      } catch {
        return false
      }
    },
    normalizarData(data) {
      if (!data) return null
      try {
        if (typeof data === 'string' && data.match(/^\d{4}-\d{2}-\d{2}/)) {
          const dateStr = data.substring(0, 10) // Pega apenas YYYY-MM-DD
          const [year, month, day] = dateStr.split('-')
          return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
        }
        const date = new Date(data)
        if (isNaN(date.getTime())) return null
        return new Date(date.getFullYear(), date.getMonth(), date.getDate())
      } catch {
        return null
      }
    },
    getMeioIcon(meio) {
      if (!meio) return ''
      const meioLower = meio.toLowerCase()
      if (meioLower.includes('presencial')) {
        return 'icofont-users-alt-4'
      } else if (meioLower.includes('telepresen')) {
        return 'icofont-video-alt'
      } else if (meioLower.includes('online')) {
        return 'icofont-computer'
      }
      return 'icofont-calendar'
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    isItemExpanded(item) {
      if (!item || !item.id || !Array.isArray(this.expanded)) return false
      const originalItem = this.certificados.find((c) => c.id === item.id)
      if (!originalItem) return false
      return this.expanded.some((expandedItem) => {
        if (expandedItem === originalItem) return true
        if (
          expandedItem &&
          typeof expandedItem === 'object' &&
          expandedItem.id
        ) {
          return expandedItem.id === originalItem.id
        }
        return false
      })
    },
    onExpandedUpdate(value) {
      if (
        Array.isArray(value) &&
        JSON.stringify(value) !== JSON.stringify(this.expanded)
      ) {
        this.expanded = value
      }
      this.$nextTick(() => {
        this.ajustarLarguraExpanded()
      })
    },
    toggleExpandByItem(item) {
      this.toggleExpand(item)
    },
    toggleExpand(item) {
      if (!item || !item.id) return
      if (!Array.isArray(this.expanded)) {
        this.$set(this, 'expanded', [])
      }
      const originalItem = this.certificados.find((c) => c.id === item.id)
      if (!originalItem) return
      const currentExpanded = [...this.expanded]
      const expandedIndex = currentExpanded.findIndex((expandedItem) => {
        if (expandedItem === originalItem) return true
        if (
          expandedItem &&
          typeof expandedItem === 'object' &&
          expandedItem.id
        ) {
          return expandedItem.id === originalItem.id
        }
        return false
      })
      let newExpanded
      if (expandedIndex > -1) {
        newExpanded = currentExpanded.filter(
          (_, index) => index !== expandedIndex
        )
      } else {
        newExpanded = [...currentExpanded, originalItem]
      }
      this.$set(this, 'expanded', newExpanded)

      this.$nextTick(() => {
        this.ajustarLarguraExpanded()
      })
    },
    adicionarClickNasLinhas() {
      this.$nextTick(() => {
        const tbody = document.querySelector('.v-data-table tbody')
        if (!tbody) return
        if (this.clickHandlerAdded && this._clickHandler) {
          tbody.removeEventListener('click', this._clickHandler)
        }
        this._clickHandler = (e) => {
          const row = e.target.closest('tr')
          if (!row) return
          if (row.classList.contains('v-data-table__expanded__content')) return
          if (e.target.closest('.btn-expand')) return
          if (e.target.closest('.btn-certificado')) return
          if (e.target.closest('.btn-avaliar-principal')) return
          let itemId = e.target.getAttribute('data-item-id')
          if (!itemId) {
            const itemIdElement = row.querySelector('[data-item-id]')
            if (itemIdElement)
              itemId = itemIdElement.getAttribute('data-item-id')
          }
          if (itemId) {
            const item = this.certificados.find((c) => c.id === itemId)
            if (item) {
              e.stopPropagation()
              e.preventDefault()
              this.toggleExpand(item)
            }
          } else {
            const allRows = Array.from(tbody.querySelectorAll('tr'))
            const mainRows = allRows.filter(
              (r) => !r.classList.contains('v-data-table__expanded__content')
            )
            const rowIndex = mainRows.indexOf(row)

            if (rowIndex >= 0 && rowIndex < this.certificados.length) {
              const item = this.certificados[rowIndex]
              if (item && item.id) {
                e.stopPropagation()
                e.preventDefault()
                this.toggleExpand(item)
              }
            }
          }
        }

        tbody.addEventListener('click', this._clickHandler)
        this.clickHandlerAdded = true
      })
    },
    todasOficinasAvaliadas(item) {
      if (!item.detalhes_oficinas || item.detalhes_oficinas.length === 0)
        return false
      return item.detalhes_oficinas.every(
        (oficina) => oficina.st_part_avaliou === 1
      )
    },
    extrairNomeArquivo(caminho) {
      if (!caminho || typeof caminho !== 'string') return null
      const partes = caminho.split('/')
      return partes.length > 0 ? partes[partes.length - 1] : null
    },
    async visualizarCertificadoPrincipal(item) {
      const codIbge = this.codIbge
      const cpf = this.cpfUsuario

      if (!codIbge || !cpf) {
        this.$toast.error(
          'Dados insuficientes para visualizar o certificado.',
          'Erro',
          {
            position: 'topRight',
            timeout: 3000,
          }
        )
        return
      }

      this.loadingPdf = true
      this.mostrarModalPdf = true
      if (this.urlPdf) {
        window.URL.revokeObjectURL(this.urlPdf)
        this.urlPdf = null
      }
      let nomeParticipante = this.nomeParticipante || ''
      let brasao = null
      let logotipo = null
      const infoStore = this.$store.state.infoMunicipio
      if (infoStore) {
        brasao = this.extrairNomeArquivo(infoStore.brasao)
        logotipo = this.extrairNomeArquivo(infoStore.logotipo)
      }
      try {
        const token = this.$store.state.accessToken
        if (token) {
          const decoded = jwtDecode(token)
          if (!nomeParticipante) {
            nomeParticipante = decoded.nome || decoded.username || ''
          }
          if (infoStore == null) {
            const infoToken =
              decoded.infoMunicipio || decoded.info_municipio || {}
            brasao = this.extrairNomeArquivo(infoToken.brasao)
            logotipo = this.extrairNomeArquivo(infoToken.logotipo)
          }
        }
      } catch (e) {}

      // Define o nome do arquivo do certificado com base no nome do profissional
      const nomeLimpo = (nomeParticipante || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
      const sufixo = nomeLimpo || 'profissional'
      this.nomeArquivoPdf = `certificado_${sufixo}.pdf`

      const facilitador =
        item.detalhes_oficinas?.length > 0
          ? item.detalhes_oficinas[0].facilitador || null
          : null

      const payload = {
        cpf: cpf,
        nome_participante: nomeParticipante,
        id_titulo: item.id_titulo,
        titulo: item.titulo,
        subtitulo: item.subtitulo,
        horas_acumuladas: parseInt(item.horas_acumuladas, 10) || 0,
        ult_atividade: item.ult_atividade,
        facilitador,
        brasao,
        logotipo,
        detalhes_oficinas:
          typeof item.detalhes_oficinas === 'string'
            ? item.detalhes_oficinas
            : JSON.stringify(item.detalhes_oficinas || []),
      }

      const url = `/app/oficinas-treinamentos/${codIbge}/certificados/geral`

      try {
        const response = await this.$api.post(url, payload, {
          responseType: 'blob',
        })

        if (response.data) {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          this.urlPdf = window.URL.createObjectURL(blob)
        } else {
          throw new Error('Resposta vazia do servidor')
        }
      } catch (error) {
        this.$toast.error(
          'Erro ao carregar o certificado. Tente novamente.',
          'Erro',
          {
            position: 'topRight',
            timeout: 3000,
          }
        )
        this.mostrarModalPdf = false
      } finally {
        this.loadingPdf = false
      }
    },
    expandirParaAvaliar(item) {
      if (!this.isItemExpanded(item)) this.toggleExpand(item)
      this.$nextTick(() => {
        const expandedRow = document.querySelector(
          `.v-data-table__expanded[data-item-id="${item.id}"]`
        )
        if (expandedRow) {
          expandedRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      })
    },
    async visualizarCertificado(certificado, oficina) {
      const codIbge = this.codIbge
      const cpf = this.cpfUsuario

      if (!codIbge || !cpf || !oficina?.id) {
        this.$toast.error(
          'Dados insuficientes para visualizar o certificado.',
          'Erro',
          {
            position: 'topRight',
            timeout: 3000,
          }
        )
        return
      }

      this.loadingPdf = true
      this.mostrarModalPdf = true
      if (this.urlPdf) {
        window.URL.revokeObjectURL(this.urlPdf)
        this.urlPdf = null
      }
      // Define o nome do arquivo com base no nome do profissional
      const nomeParticipante = this.nomeParticipante || ''
      const nomeLimpo = nomeParticipante
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
      const sufixo = nomeLimpo || 'profissional'
      this.nomeArquivoPdf = `certificado_${sufixo}.pdf`
      const cpfLimpo = String(cpf).replace(/\D/g, '')
      const url = `/app/oficinas-treinamentos/${codIbge}/certificados/oficinas`

      try {
        const response = await this.$api.post(
          url,
          {
            id_oficina: oficina.id,
            cpf: cpfLimpo,
          },
          {
            responseType: 'blob',
          }
        )
        const blob = new Blob([response.data], { type: 'application/pdf' })
        this.urlPdf = window.URL.createObjectURL(blob)
        this.loadingPdf = false
      } catch (error) {
        this.loadingPdf = false
        this.mostrarModalPdf = false
        this.$toast.error(
          'Erro ao carregar o certificado. Tente novamente.',
          'Erro',
          {
            position: 'topRight',
            timeout: 3000,
          }
        )
      }
    },
    fecharModalPdf() {
      this.mostrarModalPdf = false
      if (this.urlPdf) {
        window.URL.revokeObjectURL(this.urlPdf)
        this.urlPdf = null
      }
    },
    handleAvaliar(oficina, certificado) {
      const oficinaParaAvaliacao = {
        ...oficina,
        id: oficina.id,
        titulo: oficina.titulo || certificado.titulo,
        sub_titulo: oficina.sub_titulo || certificado.subtitulo,
        dataAtividade: oficina.inicio,
        data_atividade: oficina.inicio,
        meio: oficina.meio,
        facilitador: oficina.facilitador,
      }
      this.oficinaSelecionadaParaAvaliacao = oficinaParaAvaliacao
      this.mostrarModalAvaliacao = true
    },
    fecharModalAvaliacao() {
      this.mostrarModalAvaliacao = false
      this.oficinaSelecionadaParaAvaliacao = null
    },
    async onAvaliacaoEnviada() {
      const itemExpandidoId = this.oficinaSelecionadaParaAvaliacao?.id
        ? this.certificados.find((c) =>
            c.detalhes_oficinas?.some(
              (o) => o.id === this.oficinaSelecionadaParaAvaliacao.id
            )
          )?.id
        : null
      await this.buscarCertificados()
      if (itemExpandidoId) {
        const itemParaExpandir = this.certificados.find(
          (c) => c.id === itemExpandidoId
        )
        if (itemParaExpandir && !this.isItemExpanded(itemParaExpandir)) {
          this.toggleExpand(itemParaExpandir)
        }
      }

      this.fecharModalAvaliacao()
    },
    ajustarLarguraExpanded() {
      this.$nextTick(() => {
        const expandedRows = document.querySelectorAll(
          '.v-data-table__expanded'
        )

        if (!expandedRows.length) return

        expandedRows.forEach((row) => {
          const expandedCell = row.querySelector('.expanded-cell')
          if (expandedCell) {
            expandedCell.style.width = ''
            expandedCell.style.maxWidth = ''
            expandedCell.style.minWidth = ''
          }

          const detalhesWrapper = row.querySelector(
            '.detalhes-oficinas-wrapper'
          )
          if (detalhesWrapper) {
            detalhesWrapper.style.width = ''
            detalhesWrapper.style.maxWidth = ''
            detalhesWrapper.style.minWidth = ''
          }

          const tabelaOficinas = row.querySelector('.tabela-oficinas')
          if (tabelaOficinas) {
            tabelaOficinas.style.width = ''
            tabelaOficinas.style.maxWidth = ''
            tabelaOficinas.style.minWidth = ''
          }
        })
      })
    },
  },
}
</script>

<style scoped>
/* ===== Layout Principal ===== */
.card-topo {
  border-radius: 15px 15px 0 0;
  border-bottom: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.card {
  border: 1px solid #e0e0e0;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-top: none;
}

.box {
  margin-top: 0;
}

.tabela {
  padding: 0;
  width: 100%;
}

.input-bottom {
  margin-bottom: 0;
}

.paginacao {
  font-size: 0.875rem;
  color: #6c757d;
}

/* ===== Botão Voltar ===== */
.btn-voltar-circular {
  background-color: #fff;
  border: 1px solid #dee2e6;
  color: #6c757d;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.btn-voltar-circular i {
  font-size: 1.2rem;
}

.btn-voltar-circular:hover {
  background-color: #f8f9fa;
  color: #0fafd7;
  border-color: #0fafd7;
  transform: translateX(-2px);
}

/* ===== Botão Expandir ===== */
.btn-expand {
  background: transparent;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  border-radius: 4px;
}

.btn-expand:hover {
  color: #0fafd7;
  background-color: #f8f9fa;
}

.btn-expand i {
  font-size: 1.2rem;
}

/* ===== Expanded Content ===== */
.expanded-cell {
  padding: 16px !important;
  background-color: #f5f5f5;
  vertical-align: top !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  position: relative !important;
  z-index: 1 !important;
  box-sizing: border-box !important;
}

.detalhes-oficinas-wrapper {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  overflow-x: auto;
  overflow-y: visible;
}

.tabela-oficinas {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
}

.tabela-oficinas ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}

.tabela-oficinas ::v-deep table {
  width: 100%;
}

.tabela-oficinas ::v-deep .v-data-table tbody td {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
  padding: 12px 16px;
}

.tabela-oficinas ::v-deep .v-data-table thead th {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}

.tag-categoria,
.tag-acumulado {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border-radius: 0;
  font-size: 0.875rem;
  font-weight: 400;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.5;
}

.certificado-data {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.5;
}

.certificado-titulo {
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
  line-height: 1.5;
}

.certificado-meio {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.5;
}

.horas-individual {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.5;
}

.certificado-acoes {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-visualizar,
.btn-avaliar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 12px;
  min-height: 32px;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  line-height: 1.4;
}

.btn-visualizar {
  color: rgba(0, 0, 0, 0.87);
  background-color: #fff;
}

.btn-visualizar:hover {
  background-color: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.12);
}

.btn-visualizar i {
  font-size: 0.8125rem;
}

.btn-avaliar {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}

.btn-avaliar:hover {
  background-color: #1976d2;
  border-color: #1976d2;
}

.btn-avaliar i {
  font-size: 0.8125rem;
}

.btn-avaliado {
  background-color: #9e9e9e;
  border-color: #9e9e9e;
  cursor: default;
}

.btn-avaliado:hover {
  background-color: #9e9e9e;
  border-color: #9e9e9e;
}

.certificados-coluna {
  display: flex;
  align-items: center;
}

.btn-certificado,
.btn-avaliar-principal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 12px;
  min-height: 32px;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  line-height: 1.4;
}

.btn-certificado {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-certificado:hover {
  background-color: #218838;
  border-color: #218838;
}

.btn-certificado i {
  font-size: 0.8125rem;
}

.btn-avaliar-principal {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}

.btn-avaliar-principal:hover {
  background-color: #1976d2;
  border-color: #1976d2;
}

.btn-avaliar-principal i {
  font-size: 0.8125rem;
}

.certificado-empty {
  padding: 24px;
  text-align: center;
  color: #6c757d;
  font-size: 0.9375rem;
}

/* ===== Vuetify Data Table ===== */
.v-data-table,
.v-data-table__wrapper {
  overflow: visible !important;
  width: 100%;
}

.v-data-table table {
  overflow: visible !important;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.v-data-table tbody,
.v-data-table tbody tr,
.v-data-table tbody td {
  overflow: visible !important;
}

.v-data-table tbody td {
  padding: 12px 16px;
  position: relative;
}

/* Linhas clicáveis */
.v-data-table tbody tr:not(.v-data-table__expanded) {
  cursor: pointer;
  transition: background-color 0.2s;
}

.v-data-table tbody tr:not(.v-data-table__expanded):hover {
  background-color: #f8f9fa;
}

.v-data-table thead th {
  white-space: nowrap;
}

.v-card {
  width: 100%;
}

.v-card__title {
  width: 100%;
  padding: 16px 24px;
}

.v-card__title .v-text-field {
  width: 100%;
}

/* ===== Expanded Row Styles ===== */
.v-data-table__expanded,
.v-data-table__expanded__content {
  display: table-row !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Garantir que o expanded não altere o layout da tabela principal */
.v-data-table table {
  table-layout: fixed;
}

.v-data-table thead th {
  width: auto;
}

.v-data-table tbody tr:not(.v-data-table__expanded) td {
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Garantir larguras fixas para manter layout consistente */
.v-data-table thead th:nth-child(1) {
  width: 50%;
}

.v-data-table thead th:nth-child(2) {
  width: 20%;
}

.v-data-table thead th:nth-child(3) {
  width: calc(25% - 48px);
}

.v-data-table thead th:nth-child(4),
.v-data-table tbody tr:not(.v-data-table__expanded) td:nth-child(4) {
  width: 48px;
  min-width: 48px;
  max-width: 48px;
}

.v-data-table tbody tr.expanded-row td:not(.expanded-cell) {
  padding: 12px 16px;
}

.v-data-table tbody tr.expanded-row td.expanded-cell,
.v-data-table tbody td[colspan].expanded-cell,
.v-data-table__expanded td.expanded-cell,
.v-data-table__expanded__content td.expanded-cell {
  padding: 8px !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  position: relative !important;
  z-index: 1 !important;
  box-sizing: border-box !important;
}

.v-data-table__expanded td,
.v-data-table__expanded__content td {
  display: table-cell !important;
}

/* ===== Expanded Content Width ===== */
.v-data-table__expanded .detalhes-oficinas-wrapper,
.v-data-table__expanded__content .detalhes-oficinas-wrapper,
.v-data-table__expanded .certificado-cards,
.v-data-table__expanded__content .certificado-cards {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

.v-data-table__expanded .certificado-card,
.v-data-table__expanded__content .certificado-card {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
  margin: 0 !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
  box-sizing: border-box !important;
}
</style>
